import { render, staticRenderFns } from "./CusDocSch.vue?vue&type=template&id=4854cca6&scoped=true&"
import script from "./CusDocSch.vue?vue&type=script&lang=js&"
export * from "./CusDocSch.vue?vue&type=script&lang=js&"
import style0 from "./CusDocSch.vue?vue&type=style&index=0&id=4854cca6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4854cca6",
  null
  
)

export default component.exports